import React, { useId, useEffect, useState, memo } from "react";
import Particles, { initParticlesEngine } from "@tsparticles/react";
import { loadSlim } from "@tsparticles/slim";
import { cn } from "../../lib/utils";

export const SparklesCore = memo(({
  id,
  className,
  background,
  minSize = 1,
  maxSize = 3,
  speed = 4,
  particleColor = "#FFFFFF",
  particleDensity = 120,
}) => {
  const [init, setInit] = useState(false);
  useEffect(() => {
    initParticlesEngine(async (engine) => {
      await loadSlim(engine);
    }).then(() => {
      setInit(true);
    });
  }, []);

  const generatedId = useId();
  const particlesId = id || generatedId;

  if (!init) return null; // Render nothing until the engine is initialized

  return (
    <div className={cn("h-full w-full", className)}>
      <Particles
        id={particlesId}
        options={{
          background: {
            color: {
              value: background || "transparent",
            },
          },
          fullScreen: {
            enable: false,
            zIndex: 1,
          },
          fpsLimit: 120,
          interactivity: {
            events: {
              onClick: {
                enable: true,
                mode: "push",
              },
              onHover: {
                enable: false,
                mode: "repulse",
              },
              resize: true,
            },
            modes: {
              push: {
                quantity: 4,
              },
              repulse: {
                distance: 200,
                duration: 0.4,
              },
            },
          },
          particles: {
            color: {
              value: particleColor,
            },
            move: {
              direction: "none",
              enable: true,
              outModes: {
                default: "out",
              },
              random: true,
              speed: speed,
              straight: false,
            },
            number: {
              density: {
                enable: true,
                area: 800,
              },
              value: particleDensity,
            },
            opacity: {
              value: {
                min: 0.1,
                max: 1,
              },
              animation: {
                enable: true,
                speed: speed,
                sync: false,
              },
            },
            shape: {
              type: "circle",
            },
            size: {
              value: {
                min: minSize,
                max: maxSize,
              },
              animation: {
                enable: true,
                speed: speed,
                sync: false,
              },
            },
          },
          detectRetina: true,
        }}
      />
    </div>
  );
}); 